import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRoller: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRoller"><Path d="M13 4V5.5H15.4011L17.1633 13.2643C16.1174 13.6969 15.3269 14.6217 15.0805 15.75H8.91946C8.57612 14.1774 7.17556 13 5.5 13C3.567 13 2 14.567 2 16.5C2 18.433 3.567 20 5.5 20C7.17556 20 8.57612 18.8226 8.91946 17.25H15.0805C15.4239 18.8226 16.8244 20 18.5 20C20.433 20 22 18.433 22 16.5C22 14.6146 20.5092 13.0774 18.6421 13.0028L16.5989 4H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRoller;
